import React from 'react';
import {toast} from 'react-toastify';

const UNDO_TOAST_ID = 'agency-prompts-undo';
const AUTO_CLOSE_MS = 8000;

function UndoToastContent({message, undoLabel, onUndo, closeToast}) {
    return (
        <div className="agp-toast">
            <span className="agp-toast__message">{message}</span>
            <button type="button" className="agp-toast__undo"
                    onClick={() => { onUndo(); if (closeToast) closeToast(); }}>
                {undoLabel}
            </button>
        </div>
    );
}

/**
 * «Prompt desactivado.» con «Deshacer» durante 8 segundos, en lugar de un modal de confirmación.
 *
 * Un solo `toastId`: react-toastify DESCARTA en silencio un `toast()` con un id activo (gotcha del
 * repo), así que desactivar dos prompts seguidos actualiza el mismo aviso. `updateId` cambia con
 * cada prompt para que el botón deshaga el ÚLTIMO y el temporizador vuelva a empezar (el caso que
 * rompió el toast de Informes, QA caso 09).
 */
export function showUndoToast({message, undoLabel, onUndo, actionId}) {
    const render = ({closeToast}) => (
        <UndoToastContent message={message} undoLabel={undoLabel} onUndo={onUndo} closeToast={closeToast}/>
    );
    const options = {
        toastId: UNDO_TOAST_ID,
        updateId: String(actionId),
        autoClose: AUTO_CLOSE_MS,
        closeOnClick: false,
        pauseOnHover: true,
    };
    if (toast.isActive(UNDO_TOAST_ID)) {
        toast.update(UNDO_TOAST_ID, {...options, render});
    } else {
        toast(render, options);
    }
}

export function dismissUndoToast() {
    toast.dismiss(UNDO_TOAST_ID);
}
